import { render, staticRenderFns } from "./AppTableApprovals.vue?vue&type=template&id=729be460&"
import script from "./AppTableApprovals.vue?vue&type=script&lang=ts&"
export * from "./AppTableApprovals.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableApprovals.vue?vue&type=style&index=0&id=729be460&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports